// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1CJl9","modalForm":"UpgradeEpcsModal_modalForm__17toe","modalFooter":"UpgradeEpcsModal_modalFooter__1DmZc"};